import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { Box, Checkbox, Divider, InputLabel, ListItemText } from '@mui/material';
import {
  renderCapitalised,
  renderStatusFilter,
  SELECT_ALL_VALUE,
} from 'utils/functions/filterHelpers';
import { STATUS_ITEMS } from 'constants/requestStatus';

const Controls = ({ statusFilter, setStatusFilter, setPage, setNameFilter, nameFilter }) => {
  const handleChange = event => {
    const {
      target: { value },
    } = event;
    const newStatusFilter = typeof value === 'string' ? value.split(',') : value;

    if (!statusFilter.includes(SELECT_ALL_VALUE) && newStatusFilter.includes(SELECT_ALL_VALUE)) {
      setStatusFilter([...STATUS_ITEMS, SELECT_ALL_VALUE]);
    } else if (
      statusFilter.includes(SELECT_ALL_VALUE) &&
      !newStatusFilter.includes(SELECT_ALL_VALUE)
    ) {
      setStatusFilter([]);
    } else if (
      statusFilter.includes(SELECT_ALL_VALUE) &&
      newStatusFilter.includes(SELECT_ALL_VALUE) &&
      statusFilter.length !== newStatusFilter.length
    ) {
      const index = newStatusFilter.indexOf(SELECT_ALL_VALUE);
      if (index > -1) {
        newStatusFilter.splice(index, 1);
      }
      setStatusFilter(newStatusFilter);
    } else {
      setStatusFilter(newStatusFilter);
    }

    setPage(0);
  };

  const handleNameFilterChange = event => {
    setNameFilter(event.target.value);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FormControl
          sx={{
            width: '11.5rem',

            '@media (max-width:480px)': {
              width: '100%',
              marginTop: '0.75rem',
            },

            '&:not(:last-child)': {
              marginRight: '15px',
            },
          }}
        >
          <TextField
            variant="standard"
            onChange={handleNameFilterChange}
            value={nameFilter}
            id="name-filter"
            label="Name"
          />
        </FormControl>

        <FormControl
          sx={{
            width: '11.5rem',

            '@media (max-width:480px)': {
              width: '100%',
              marginTop: '0.75rem',
            },

            '&:not(:last-child)': {
              marginRight: 15,
            },
          }}
        >
          <InputLabel id="status-filter-label">Status</InputLabel>
          <Select
            variant="standard"
            value={statusFilter}
            onChange={handleChange}
            id="status-filter"
            multiple
            renderValue={statusFilter => renderStatusFilter(statusFilter)}
            labelId="status-filter-label"
            label="Status"
          >
            <MenuItem key={SELECT_ALL_VALUE} value={SELECT_ALL_VALUE}>
              <Checkbox checked={statusFilter.indexOf(SELECT_ALL_VALUE) > -1} color="primary" />
              <ListItemText primary={SELECT_ALL_VALUE} />
            </MenuItem>
            <Divider />
            {STATUS_ITEMS.map(value => (
              <MenuItem key={value} value={value}>
                <Checkbox checked={statusFilter.indexOf(value) > -1} color="primary" />
                <ListItemText primary={renderCapitalised(value)} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

Controls.propTypes = {
  statusFilter: PropTypes.array.isRequired,
  setStatusFilter: PropTypes.func.isRequired,
  setNameFilter: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  nameFilter: PropTypes.string.isRequired,
};

export default Controls;
